/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages */
// Not a good idea to use experiment prefix in potentially long-lasting i18n strings
import { defineMessages } from 'react-intl';

export const i18n: {
	weAddedFeatures: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	toChangeYourView: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	customizeSidebar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	gotIt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	weAddedFeatures: {
		id: 'creation-focused-nav.we-added-features',
		defaultMessage: 'We added features to your sidebar',
		description: 'Heading for spotlight that highlights features added to the Confluence sidebar',
	},
	toChangeYourView: {
		id: 'creation-focused-nav.toChangeYourView',
		defaultMessage: 'To change your view, customize your sidebar in the {menuName} menu',
		description:
			'Body text for spotlight that highlights features added to the Confluence sidebar. Tells users to click either "More" or "Customize sidebar" menu',
	},
	more: {
		id: 'creation-focused-nav.more',
		defaultMessage: 'More',
		description:
			'Name of the "More" menu. This string is passed for the {menuName} placeholder in the "creation-focused-nav.toChangeYourView" message',
	},
	customizeSidebar: {
		id: 'creation-focused-nav.customizeSidebar',
		defaultMessage: 'Customize sidebar',
		description:
			'Name of the "Customize sidebar" menu. This string is passed for the {menuName} placeholder in the "creation-focused-nav.toChangeYourView" message',
	},
	gotIt: {
		id: 'creation-focused-nav.gotIt',
		defaultMessage: 'Got it',
		description: 'Text for the button to dismiss the "More" button spotlight',
	},
});
